import { render, staticRenderFns } from "./pray_home.vue?vue&type=template&id=86de6514&scoped=true"
import script from "./pray_home.vue?vue&type=script&lang=js"
export * from "./pray_home.vue?vue&type=script&lang=js"
import style0 from "./pray_home.vue?vue&type=style&index=0&id=86de6514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86de6514",
  null
  
)

export default component.exports